import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromSignin from '../../../store/reducers';
import { RenewPasswordActions } from '../../../store/actions';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-renew-password',
  templateUrl: './renew-password.component.html',
  styleUrls: ['./renew-password.component.scss']
})
export class RenewPasswordComponent implements OnInit {

  renewPasswordToken$: Observable<string>;
  renewPasswordTokenExpired$: Observable<boolean>;
  renewPasswordTokenInvalid$: Observable<boolean>;
  renewPasswordLoading$: Observable<boolean>;
  renewPasswordSuccess$: Observable<boolean>;
  renewPasswordError$: Observable<any>;

  passwordPattern = '^.{4,}$';
  renewPasswordForm: FormGroup;
  submitted = false;

  constructor(
    private router: Router,
    private store$: Store<fromSignin.State>,
    private route: ActivatedRoute
  ) {
    this.route.params
      .pipe(map(params => RenewPasswordActions.decodeMessage({ message: params.message }))).subscribe(action => {
        this.store$.dispatch(action);
      });

    this.renewPasswordToken$ = this.store$.select(fromSignin.getRenewPasswordToken);
    this.renewPasswordTokenExpired$ = this.store$.select(fromSignin.getRenewPasswordTokenExpired);
    this.renewPasswordTokenInvalid$ = this.store$.select(fromSignin.getRenewPasswordTokenInvalid);
    this.renewPasswordLoading$ = this.store$.select(fromSignin.getRenewPasswordLoading);
    this.renewPasswordSuccess$ = this.store$.select(fromSignin.getRenewPasswordSuccess);
    this.renewPasswordError$ = this.store$.select(fromSignin.getRenewPasswordError);
  }

  get f() { return this.renewPasswordForm.controls; }

  ngOnInit() {
    this.renewPasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.pattern(this.passwordPattern)]),
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.renewPasswordForm.invalid) {
      return;
    }

    this.store$.dispatch(RenewPasswordActions.renewPassword({ password: this.renewPasswordForm.value.password }));

  }

  redirectToForgotPassword() {
    this.router.navigateByUrl('/signin/forgot/password');
  }

}
